import styled from 'styled-components';

const Container = styled.div`
  background-color: #fff;
  height: 100%;
  max-width: 1024px;
  max-height: 1024px;

  padding: 2rem;

  border-radius: 5px;

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 25% 1fr;

  overflow-y: scroll;
`;

// ? HEADER
const Header = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderInfoContainer = styled.div`
  height: 90%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

const HeaderTitle = styled.h2`
  font-family: 'Lato';
  font-size: 24px;
  color: #000;
`;

const HeaderSubTitle = styled.h3`
  font-family: 'Lato';
  font-weight: 500;
  font-size: 15px;
  color: #2c2c2c;
`;

// ? MAIN
const Main = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr;

  margin-top: 2rem;
`;

// ? STUDENT PICTURE
const StudentPicContainer = styled.div`
  margin-right: 1rem;
  height: 90%;

  max-width: 250px;
  max-height: 250px;
`;

const StudentPic = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;

  border-radius: 5px;
`;

// ? STUDENT DATA
const StudentDataColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const StudentDataContainer = styled.div`
  border-radius: 10px solid black;

  margin-bottom: 2rem;
`;

const StudentDataTitle = styled.h4`
  color: #000;
  font-weight: 700;
  font-family: 'Lato';
  font-size: 17px;
`;

const StudentDataSubTitle = styled.h5`
  color: #2c2c2c;
  font-weight: 500;
  font-family: 'Lato';
  font-size: 15px;
`;

const Styles = {
  Container,
  Header,
  HeaderInfoContainer,
  HeaderTitle,
  HeaderSubTitle,
  Main,
  StudentPicContainer,
  StudentPic,
  StudentDataColumn,
  StudentDataContainer,
  StudentDataTitle,
  StudentDataSubTitle,
};

export default Styles;
